import { Context } from '@nuxt/types/app'
import { Middleware } from '@nuxt/types'
import MeUseCase from '@/usecases/auth/GetMeUseCase'
import menus from '@/assets/menu'

export const initialize: Middleware = ({ App, redirect }: Context) => {
  if (App.user.entity.initialize !== 'finished' && App.state.initialize === null) {
    if (App.state.current?.id !== App.user.entity.initialize) {
      redirect({ name: App.user.entity.initialize })
    }
  }

  if (App.user.current?.flags?.withdraw) {
    if (App.state.current?.id !== 'account-withdraw') {
      redirect({ name: 'account-withdraw' })
    }
  }
}

export const route: Middleware = ({ App, route, from }: Context) => {
  // 一つ前のルートを保存して、保存されている場合はそのページに戻る
  App.state.from = from.name !== route.name ? from.fullPath : null
  // ルートを取ってきて設定されているメニューと一致しているかを判定
  App.state.current = menus.find((prop) => prop?.id === route.name)
}

export const authenticated: Middleware = ({ App, route, redirect }: Context) => {
  // リダイレクト先を保存
  App.state.redirect = route.fullPath

  if (!App.auth.token) {
    redirect('/login')
  }
}

export const me: Middleware = async ({ App, error, app }: Context) => {
  if (!App.user.current) {
    await new MeUseCase(App).execute()
  }

  if (App.user.current) {
    app.$cookies.set('userId', App.user.current.id, { path: '/', maxAge: 60 * 60 * 24 * 14, httpOnly: false }) // 2週間
  }

  // ロールによって見れないページのときは404を出す
  if (App.state.current?.policy && !App.state.current?.policy.includes(App.user.entity.role)) {
    error({ statusCode: 404, message: 'Page not found' })
  }
}
